/** Presigned media URLs from the API typically expire in ~1 hour. */
export const PUBLIC_PRESIGNED_URL_STALE_MS = 25 * 60 * 1000;

export const PUBLIC_PRESIGNED_URL_GC_MS = 35 * 60 * 1000;
